export default __webpack_public_path__ + "static/media/img_2.68d4ea07.jpg";